export enum CustomFieldType {
    TEXT = 'TEXT',
    SELECTION = 'SELECTION'
}
